module.exports = __webpack_public_path__ + "static/media/elixir-branding-img-1.7742ac89.jpg";